import React from 'react';
// Brand asset: https://www.feishu.cn/favicon.ico (2026-09-08).
export default function FeishuIcon({size=18}:{size?:number}) {
  return <img src="/brands/feishu.ico" width={size} height={size} alt="" aria-hidden="true" style={{display:'block',flexShrink:0}} />;
}
